var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245.45 71.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Raleway-Bold, Raleway;\n        font-size: 72.53px;\n        font-weight: 700;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        font-family: Raleway-Medium, Raleway;\n        font-size: 11.72px;\n        font-weight: 500;\n        letter-spacing: .04em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(-.33 52.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CABOS")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(48.91 70.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CASTING AND BOOKING SYSTEM"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabosLogo);
export default __webpack_public_path__ + "static/media/cabos-logo.72ab086bfa3ccb8f22f2080290c42da6.svg";
export { ForwardRef as ReactComponent };